import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

const getColumns = (ratingsMapping) => ([
  {
    name: 'ccy',
    title: 'CCY',
    className: alignStyles.alignLeft,
    tooltipContent: 'Currency',
    width: 40,
  },
  {
    name: 'sze',
    title: 'SIZE (M)',
    className: alignStyles.alignRight,
    tooltipContent: 'Issue Size in Millions',
    width: 90,
  },
  {
    name: 'TNR',
    title: 'TNR',
    className: alignStyles.alignCenter,
    tooltipContent: 'Tenor',
    width: 30,
  },
  {
    name: 'MTY',
    title: 'MTY',
    className: alignStyles.alignCenter,
    tooltipContent: 'Maturity Date',
    width: 80,
  },
  {
    name: 'RNK',
    title: 'RNK',
    className: alignStyles.alignCenter,
    tooltipContent: 'Rank',
    width: 120,
  },
  ...ratingsMapping.map((rating) => ({
    name: rating.abbreviation,
    title: rating.abbreviation,
    className: alignStyles.alignCenter,
    tooltipContent: `${ rating.displayName } Rating`,
    width: 60,
  })),
  {
    name: 'TYPE',
    title: 'TYPE',
    className: alignStyles.alignCenter,
    tooltipContent: 'Coupon Type',
    width: 70,
  },
  {
    name: 'BNCH',
    title: 'BNCH',
    className: alignStyles.alignCenter,
    tooltipContent: 'Benchmark',
    width: 90,
  },
  {
    name: 'IPT',
    title: 'IPT',
    className: alignStyles.alignRight,
    tooltipContent: 'Initial price talk',
    width: 90,
  },
  {
    name: 'GDNC',
    title: 'GDNC',
    className: alignStyles.alignCenter,
    tooltipContent: 'Guidance',
    width: 110,
  },
  {
    name: 'SPRD',
    title: 'SPRD',
    className: alignStyles.alignRight,
    tooltipContent: 'Spread',
    width: 110,
  },
  {
    name: 'CPN',
    title: 'CPN',
    className: alignStyles.alignRight,
    tooltipContent: 'Coupon',
    width: 80,
  },
  {
    name: 'NIC',
    title: 'NIC',
    className: alignStyles.alignRight,
    tooltipContent: 'New Issue Concession',
    width: 80,
  },
  {
    name: 'PRICE',
    title: 'PRICE',
    className: alignStyles.alignRight,
    tooltipContent: 'Issue Price',
    width: 100,
  },
]);

export default getColumns;
